import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { socialAuthTypes, usernameSignIn } from "@const/socials";
import { toggleAddEmailModal } from "@redux/addEmail/actions";
import { localstorageKeys } from "@const/store";
import storageService from "../../services/StorageService";
import handleRedirect from "../../helpers/handleRedirect";
import routes from "../../const/routes";

export const REDIRECT_PATHS = ["/", routes.SIGN_IN()];

const AuthRedirects = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isSuccess, signedWith } = useSelector(
    ({ signInReducer }) => signInReducer,
  );

  const { email, isVerified } = useSelector(
    ({ profileReducer }) => profileReducer,
  );

  useEffect(() => {
    const { accessToken } = storageService.get(localstorageKeys.session, {});
    if (!isSuccess) {
      return;
    }

    const isMetamaskSignUp = signedWith === socialAuthTypes.metamaskSignUp;
    const isMetamaskSignIn = signedWith === socialAuthTypes.metamaskSignIn;
    const isGoogleSignIn = signedWith === socialAuthTypes.googleSignIn;
    const isGoogleSignUp = signedWith === socialAuthTypes.googleSignUp;
    const isUsernameSignIn = signedWith === usernameSignIn;

    if ((isMetamaskSignIn && !isVerified) || isMetamaskSignUp) {
      dispatch(toggleAddEmailModal(true));
      return;
    }

    if (
      (isMetamaskSignIn ||
        isGoogleSignIn ||
        isUsernameSignIn ||
        isGoogleSignUp) &&
      accessToken
    ) {
      handleRedirect(navigate);
    }
  }, [email, isSuccess, isVerified, signedWith]);
};

export default AuthRedirects;
